export const COLORS = {
  primary: "#4bb0c0",
  secondary: "#f4a261",
  light: "#f8f9fa",
  border: "#e9ecef",
  text: "#2d3e50",
  textLight: "#6c757d",
  white: "#ffffff",
  danger: "#dc3545",
  success: "#28a745",
  warning: "#ffc107",
  info: "#17a2b8",
};

export const API_URL = process.env.REACT_APP_API_URL;

export interface NewProfessionForm {
  name: string;
  is_priority: boolean;
  max_free_slots: number | null;
  max_premium_slots: number | null;
  premium_price: number | null;
  export_price: number | null;
}

export const DEFAULT_NEW_PROFESSION: NewProfessionForm = {
  name: "",
  is_priority: false,
  max_free_slots: null,
  max_premium_slots: null,
  premium_price: null,
  export_price: null,
};

export interface FilterState {
  searchText: string;
  priorityFilter: string;
  userFilter: string;
  premiumPriceFilter: string;
  exportPriceFilter: string;
}

export const DEFAULT_FILTERS: FilterState = {
  searchText: "",
  priorityFilter: "all",
  userFilter: "all",
  premiumPriceFilter: "all",
  exportPriceFilter: "all",
};